export default __webpack_public_path__ + "static/media/LargeSBCTExcessiveMovementEdited.90f4dc78.png";